import type { AttemptMetrics } from '../levels/Evaluator';

export interface StoredAttempt {
  levelId: string;
  passed: boolean;
  metrics: AttemptMetrics;
  ts: number;
}

export interface UserProgress {
  unlockedLevels: string[];
  unlockedCars: string[];
  xp: number;
  badges: string[];
  attempts: StoredAttempt[];
  bestScores: Record<string, number>;
}

export function defaultProgress(): UserProgress {
  return {
    // Las conducciones libres están disponibles desde el principio, y cada
    // itinerario (automático y manual) arranca con su primer nivel abierto.
    unlockedLevels: ['l1-move-off', 'free-lot', 'm1-bite', 'free-manual'],
    unlockedCars: ['sedan', 'm-city'],
    xp: 0,
    badges: [],
    attempts: [],
    bestScores: {},
  };
}

/**
 * Migra un progreso guardado con una versión anterior: garantiza que los
 * desbloqueos por defecto (p. ej. el itinerario manual) estén presentes.
 */
export function migrateProgress(stored: UserProgress): UserProgress {
  const base = defaultProgress();
  return {
    ...base,
    ...stored,
    unlockedLevels: [...new Set([...base.unlockedLevels, ...stored.unlockedLevels])],
    unlockedCars: [...new Set([...base.unlockedCars, ...stored.unlockedCars])],
  };
}

/**
 * Interfaz de persistencia. El MVP usa IndexedDB; un backend REST podrá
 * implementar esta misma interfaz sin tocar el resto de la app.
 */
export interface StorageProvider {
  load(): Promise<UserProgress | null>;
  save(progress: UserProgress): Promise<void>;
  clear(): Promise<void>;
}

export class MemoryProvider implements StorageProvider {
  private data: UserProgress | null = null;
  load(): Promise<UserProgress | null> {
    return Promise.resolve(this.data ? structuredClone(this.data) : null);
  }
  save(progress: UserProgress): Promise<void> {
    this.data = structuredClone(progress);
    return Promise.resolve();
  }
  clear(): Promise<void> {
    this.data = null;
    return Promise.resolve();
  }
}
